import React, { useRef, useEffect } from 'react';

function RichTextEditor({ value, onChange, placeholder, style = {} }) {
  const editorRef = useRef(null);

  // Sync content only if it's different to avoid cursor jumps
  useEffect(() => {
    if (editorRef.current && editorRef.current.innerHTML !== value) {
      editorRef.current.innerHTML = value || '';
    }
  }, [value]);

  const handleInput = () => {
    const html = editorRef.current.innerHTML;
    onChange(html);
  };

  const execCommand = (command, value = null) => {
    document.execCommand(command, false, value);
    handleInput();
    editorRef.current.focus();
  };

  return (
    <div className="sa-rte-container" style={style}>
      <div className="sa-rte-toolbar">
        <button 
          className="sa-rte-tool" 
          onClick={() => execCommand('bold')}
          title="Bold"
          type="button"
        >
          <b>B</b>
        </button>
        <button 
          className="sa-rte-tool" 
          onClick={() => execCommand('italic')}
          title="Italic"
          type="button"
        >
          <i>I</i>
        </button>
        <div className="sa-rte-divider"></div>
        <button 
          className="sa-rte-tool" 
          onClick={() => execCommand('insertHorizontalRule')}
          title="Line Break"
          type="button"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
        </button>
        <div className="sa-rte-divider"></div>
        <div className="sa-rte-color-picker" title="Text Color">
          <input 
            type="color" 
            defaultValue="#ffffff"
            onChange={(e) => execCommand('foreColor', e.target.value)}
          />
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M12 19l7-7 3 3-7 7-3-3z" /><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" /><path d="M2 2l7.5 1.5" /><path d="M14 11l-4-4" />
          </svg>
        </div>
      </div>

      <div
        ref={editorRef}
        className="sa-rte-editor"
        contentEditable
        onInput={handleInput}
        placeholder={placeholder}
        onBlur={handleInput}
        spellCheck="false"
      />
    </div>
  );
}

export default RichTextEditor;
